// Centralised date/time formatting so the whole app shows dates as dd/MM/yyyy.

const pad = (n: number) => String(n).padStart(2, '0');

type DateInput = string | number | Date;

const toDate = (input: DateInput): Date | null => {
  const d = input instanceof Date ? input : new Date(input);
  return isNaN(d.getTime()) ? null : d;
};

// dd/MM/yyyy
export function formatDate(input: DateInput): string {
  const d = toDate(input);
  if (!d) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// hh:mm:ss AM/PM (12-hour)
export function formatTime(input: DateInput): string {
  const d = toDate(input);
  if (!d) return '';
  const ampm = d.getHours() >= 12 ? 'PM' : 'AM';
  const h = d.getHours() % 12 || 12;
  return `${pad(h)}:${pad(d.getMinutes())}:${pad(d.getSeconds())} ${ampm}`;
}

// dd/MM/yyyy hh:mm:ss AM/PM
export function formatDateTime(input: DateInput): string {
  const d = toDate(input);
  if (!d) return '';
  return `${formatDate(d)} ${formatTime(d)}`;
}
